/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonComponentsModule } from '../common/components/common-components.module';
import { CommunityModule } from '../common/community/community.module';
import { CommunityFeedModule } from '../common/community/feed/community-feed.module';
import { ShareMenuComponent } from '../shared/share-menu/share-menu.component';
import { ItemActionsComponent } from './item-actions.component';

// Not standalone, for the same reason as CommunityFeedModule: the action buttons and sharing pull in UpgradeModule.
@NgModule({
  imports: [CommonModule, CommonComponentsModule, CommunityModule, CommunityFeedModule, ShareMenuComponent],
  declarations: [ItemActionsComponent],
  exports: [ItemActionsComponent],
})
class ItemActionsModule {}

export { ItemActionsModule };
